import TelInput from './src/components/vue-tel-input.vue';
export default TelInput;
